<template>
    <div class="reset-password-container">
        <div class="box">
            <div class="title">
                <b-icon icon="file-lock"></b-icon>
                <h1>เกณฑ์ตั้งรหัสผ่านใหม่</h1>
                <ul>
                    <li>ควรมีความยาวอย่างน้อย 8 ตัวอักษร</li>
                    <li>รหัสผ่านควรมีตัวอักษรภาษาอังกฤษตัวเล็กและตัวใหญ่</li>
                    <li>รหัสผ่านควรประกอบไปด้วยตัวเลขอย่างน้อย 1 ตัว</li>
                    <li>รหัสผ่านควรมีอักขระพิเศษอย่างน้อย 1 ตัว</li>
                </ul>
            </div>

            <div class="forms">
                <div class="control">
                    <b-icon icon="person-fill" class="icon"></b-icon>
                    <input type="text" placeholder="อีเมล" value="test@email.com" readonly />
                </div>
                <div class="control">
                    <b-icon icon="lock-fill" class="icon"></b-icon>
                    <input :type="isShowPassword ? 'text' : 'password'" placeholder="รหัสผ่าน" v-model="formResetPassword.password" maxlength="30" />
                    <button class="show-password" @click="showPassword()"><b-icon icon="eye-fill"></b-icon></button>
                </div>
                <div class="control">
                    <b-icon icon="lock-fill" class="icon"></b-icon>
                    <input :type="isShowPasswordConfirm ? 'text' : 'password'" placeholder="ยืนยันรหัสผ่าน" v-model="formResetPassword.passwordConfirm" maxlength="30" />
                    <button class="show-password" @click="showPasswordConfirm()"><b-icon icon="eye-fill"></b-icon></button>
                </div>
            </div>

            <div class="action">
                <div class="validation" v-if="validationMessage">{{ validationMessage }}</div>
                <button class="reset" @click="resetPassword()">ตั้งรหัสผ่านใหม่</button>
            </div>
        </div>
    </div>
</template>

<script>
import Helper from '@/resources/Helper';

export default {
    data() {
        return {
            isShowPassword: false,
            isShowPasswordConfirm: false,
            validationMessage: '',
            formResetPassword: { password: '', passwordConfirm: '' }
        }
    },
    methods: {
        async resetPassword() {
            if (this.validateData()) {
                const loader = this.$AppUtility.renderLoadBackdrop();
                const result = await Helper.postAPI(Helper.getApiUrl(), '/api/reset-password', this.formData);

                if (result) {
                    this.$swal({
                        title: 'ตั้งรหัสผ่านใหม่เสร็จแล้ว',
                        text: 'โปรดทำการเข้าสู่ระบบ ร้านค้าด้วยรหัสผ่านใหม่ของท่าน',
                        icon: 'question'
                    }).then(() => {
                        location.href = "/";
                    });
                } else {
                    this.isShowNetworkError = true;
                }

                loader.hide();
            }
        },
        validateData() {
            let isValid = true;
            const regex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');

            if (!this.formResetPassword.password.trim()) {
                isValid = false;
                this.validationMessage = 'โปรดกรอกรหัสผ่าน';
            } else if (!regex.test(this.formResetPassword.password)) {
                isValid = false;
                this.validationMessage = 'รหัสผ่านไม่ตรงตามเงื่อนไขด้านบน';
            } else if (!this.formResetPassword.passwordConfirm.trim()) {
                isValid = false;
                this.validationMessage = 'โปรดยืนยันรหัสผ่าน';
            } else if (this.formResetPassword.password.trim() !== this.formResetPassword.passwordConfirm.trim()) {
                isValid = false;
                this.validationMessage = 'รหัสผ่านยืนยันไม่ตรงกัน';
            }

            return isValid;
        },
        showPassword() {
            this.isShowPassword = !this.isShowPassword;
        },
        showPasswordConfirm() {
            this.isShowPasswordConfirm = !this.isShowPasswordConfirm;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.reset-password-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $backgroundColor;
    padding: 15px;

    .box {
        background: $contentColor;
        width: 100%;
        max-width: 400px;
        padding: 40px;

        @media only screen and (max-width: $screenLarge) {
            padding: 30px 20px;
        }

        .title {
            display: block;
            text-align: center;

            .bi {
                color: #666;
                font-size: 75px;
                margin-bottom: 20px;
            }

            h1 {
                font-size: 22px;
                color: #ccc;
            }

            ul {
                font-size: 12px;
                text-align: left;
                color: #999;
                margin: 20px 0;
            }
        }

        .forms {
            background: $inputBackgroundColor;
            padding: 5px 25px;

            .control {
                position: relative;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #555;

                .bi.icon {
                    position: absolute;
                    color: #555;
                }
                
                input {
                    display: block;
                    width: 100%;
                    font-size: 15px;
                    border: none;
                    background: none;
                    outline: none;
                    padding: 15px 10px 15px 40px;
                    color: #fff;
                }

                .show-password {
                    position: absolute;
                    right: 0;
                    color: #666;
                    cursor: pointer;
                    background: none;
                    border: none;

                }

                &:last-child {
                    border-bottom: none
                }
            }
        }

        .action {
            padding-top: 25px;

            .validation {
                text-align: center;
                font-size: 13px;
                color: #ff0000;
                padding-bottom: 10px;
            }
            
            button {
                display: block;
                border: none;
                outline: none;
                margin: 5px auto;

                &:hover {
                    opacity: 0.5;
                    text-decoration: underline;
                }
                
                &.reset {
                    background: $secondaryColor;
                    color: #000;
                    font-size: 16px;
                    font-weight: bold;
                    padding: 10px 30px;
                    @include transition(all 0.2s linear);
                }
            }
        }
    }
}

::placeholder {
    color: #888;
    opacity: 1;
}
  
:-ms-input-placeholder {
    color: #888;
}
  
::-ms-input-placeholder {
    color: #888;
}
</style>